<template>
  <div v-if="bluonIntegration.config">
    <MarketplaceCard
      v-model="switchOn"
      :disabled="switchDisabled"
      logo-alt="Bluon HVAC App"
      description="Get access to 325k+ HVAC units with manuals and original parts lists using the Bluon app for HVAC technicians."
      :learn-more-link="bluonLearnMoreLink"
      cy-selector="marketplaceBluon"
    >
      <template #logo>
        <BluonLogo class="h-11 w-auto mr-auto" />
      </template>
      <template #configure>
        <div class="link" @click="openModal">Set Up Information</div>
      </template>
      <template #modal>
        <Modal
          v-if="modalOpen"
          title="Bluon Integration"
          class-name="bluon-integration-config-modal"
          submit-btn-text="Save"
          :saving="saving"
          @submit="saveIntegration"
          @hide-modal="closeModal"
        >
          <div class="d-flex flex-column">
            <strong>Departments</strong>
            <p class="mb-4">
              Please select the department(s) where you want to enable the Bluon
              integration and click save once you finish.
            </p>
            <div
              v-for="department in bluonIntegration.config.departments"
              :key="department.id"
            >
              <Checkbox
                v-model="department.bluon_enabled"
                :label="department.name"
                class="mt-2"
              />
            </div>
          </div>
        </Modal>
      </template>
    </MarketplaceCard>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getProperty } from "@/lib/helpers";

import Modal from "@/components/Modal.vue";
import Checkbox from "@/components/Seranova/Checkbox/Checkbox.vue";
import BluonLogo from "@/images/bluon_logo.svg?component";
import MarketplaceCard from "./MarketplaceCard.vue";

export default {
  components: {
    MarketplaceCard,
    Modal,
    Checkbox,
    BluonLogo
  },
  data() {
    return {
      switchDisabled: null,
      switchOn: null,
      modalOpen: false,
      saving: false
    };
  },
  computed: {
    ...mapState(["bluonIntegration"]),
    bluonLearnMoreLink: function () {
      const link = getProperty(
        this.$store.state.tenantCustomizations,
        "System.bluon_learn_more_link"
      );
      return link?.value || link?.default;
    }
  },
  watch: {
    switchOn: function (newValue, oldValue) {
      if (
        oldValue === null ||
        newValue === oldValue ||
        newValue === this.bluonIntegration.config.enabled
      ) {
        return;
      }
      newValue ? this.enableIntegration() : this.disableIntegration();
    },
    "bluonIntegration.config.enabled": function (newValue, oldValue) {
      if (oldValue !== newValue) {
        this.refreshTools();
      }
    }
  },
  mounted() {
    this.fetchBluonIntegration().then(this.refreshTools);
  },
  methods: {
    ...mapActions(["fetchBluonIntegration", "changeBluonIntegration"]),
    openModal() {
      this.fetchBluonIntegration().then(() => {
        this.modalOpen = true;
      });
    },
    closeModal() {
      return this.fetchBluonIntegration().then(() => {
        this.modalOpen = false;
        this.refreshTools();
      });
    },
    enableIntegration() {
      this.changeBluonIntegration({ enabled: true })
        .then(() => {
          window.notify.success("Bluon integration enabled!");
        })
        .catch(() => (this.switchOn = false));
    },
    disableIntegration() {
      this.changeBluonIntegration({ enabled: false }).then(() => {
        window.notify.success("Bluon integration disabled!");
      });
    },
    async saveIntegration() {
      try {
        this.saving = true;
        await this.changeBluonIntegration(this.bluonIntegration.config);
        window.notify.success("Bluon settings saved!");
        this.closeModal();
      } catch (e) {
        // form shows validation errors
      }
      this.saving = false;
    },
    // Make the state consistent
    refreshTools() {
      this.switchOn = this.bluonIntegration.config.enabled;
      if (this.switchDisabled) {
        this.switchOn = false;
      }
    }
  }
};
</script>
